export default "__VITE_ASSET__zuKU_$fa__"